module.exports = __webpack_public_path__ + "img/avatar01.047bcf26.png";